import { inject } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ResponseData } from '../interface/response';
import { AppConstant, VALIDATOR_PATTERNS } from './app-constant';
import { AlertService } from '../service/alert.service';
import { PrintDocComponent } from 'src/app/shared/feature-modal/print-doc/print-doc.component';
import { ModalService } from 'src/app/shared/service/modal.service';
import { UrlServices } from './url-services';
import { userPermission } from '../interface/user';

export function convertDate(data: any): Date | any {
  const dat = new Date(data);
  return `${dat.getFullYear()}-${dat.getMonth() + 1}-${dat.getDate()}`;
  // return dat;
}

export function createSearchTableQuery(event: any) {
  if (!event)
    return null;

  const search: any = {};
  let sortText;
  if (event.first)
    search.page = (event.first / AppConstant.TABLE_PAGE_ROWS) || 1;
  else
    search.page = 0;
  search.rows = event.rows;
  if (event.filters) {
    search.queryParams = [];
    Object.keys(event.filters).forEach(key => {
      const d = event.filters[key].value || '';
      if (d instanceof Date) {
        event.filters[key].value = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
        event.filters[key].type = 'DATE'
      } else if (typeof d == 'object') {
        event.filters[key].value = null
      }
      event.filters[key]['colName'] = key;
      if (event.filters[key].value) {
        search.queryParams.push(event.filters[key]);
      }
    });
  }
  if (event.sortField) {
    search.sort = [];
    if (event.sortOrder == 1) {
      sortText = 'asc';
    }
    else if (event.sortOrder == -1) {
      sortText = 'desc';
    }
    if (event.sortField) {
      search.sort.push({ colName: event.sortField, sortOrder: sortText });
    }
  }
  return search;
}

export function extractNumber(txt: string | number) {
  return +(String(txt).replace(/\D/g, ''));
}
export function transformTitle(str: string = '') {
  //fileName => file Name , zon_name=> Zon Name
  return str?.replace(/\_+/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camel case words
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
  // return toWordStringFirstCap(str?.replace(/\_+/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) || '');
}

export function toMonthName(monthNumber: any = new Date().getMonth(), type: 'short' | 'long' = 'short') {
  const date = new Date();
  date.setMonth(monthNumber - 1);
  return date.toLocaleString('en-US', {
    month: type,
  });
}



export function isArray(data: any) {
  if (Array.isArray(data)) {
    return data.length;
  }
  return false;
}

export function cleanForm(formGroup: UntypedFormGroup): any {
  Object.keys(formGroup.controls).forEach((key) => {
    if (formGroup.get(key)?.value && typeof formGroup.get(key)?.value == 'string')
      formGroup.get(key)?.setValue(formGroup.get(key)?.value?.trim());
  });
}


export function filterData(filters: any, data: any): any {
  if (!filters)
    return [];
  let keys: any = Object.keys(filters);
  return data.filter((item: any) => {
    return keys.every((key: any) => {
      if (typeof filters[key] !== 'function') return true;
      return filters[key](item[key]);
    });
  });
}


export function isEmailUniqueValidation(control: AbstractControl): Promise<any> | Observable<any> {
  //@ts-ignore
  const self = this;
  let regx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const promise = new Promise<any>((resolve, reject) => {
    if (self.email_id && self.email_id == control.value) {
      resolve(null);
    }
    self.emailCheckingloading = false;
    if (control.value && control.value.match(regx) !== null) {
      self.userApi.isUnique('user_name', control.value).then((data: ResponseData) => {
        if (!data.result.length) {
          resolve(null);
        } else {
          resolve({ 'isNotUnique': true });
        }
      }).catch((error: any) => {
        resolve({ 'isNotUnique': true });
      }).finally(() => {
        self.emailCheckingloading = false;
      });
    } else {
      resolve(null);
    }
  });
  return promise;
}
export function generateFinancialYearOptions(): { finYearName: string; id: string }[] {
  const today = new Date();
  const currentYear = today.getMonth() <= 4 ? today.getFullYear() : today.getFullYear() - 1;
  return [
    // { finYearName: `${currentYear - 2} - ${currentYear - 1}`, id: `${currentYear - 2}-04-014` },
    { finYearName: `${currentYear - 1} - ${currentYear}`, id: `${currentYear - 1}-04-01` },
    { finYearName: `${currentYear} - ${currentYear + 1}`, id: `${currentYear}-04-01` },
    { finYearName: `${currentYear + 1} - ${currentYear + 2}`, id: `${currentYear + 1}-04-01` }
  ];
}

export function getProdAdminYear(): { finYearName: string; id: string }[] {
  const today = new Date();
  const currentYear = today.getMonth() <= 4 ? today.getFullYear() : today.getFullYear() - 1;
  return [
    { finYearName: `${currentYear - 2} - ${currentYear - 1}`, id: `${currentYear - 2}-04-014` },
    { finYearName: `${currentYear - 1} - ${currentYear}`, id: `${currentYear - 1}-04-01` },
    { finYearName: `${currentYear} - ${currentYear + 1}`, id: `${currentYear}-04-01` },
    { finYearName: `${currentYear + 1} - ${currentYear + 2}`, id: `${currentYear + 1}-04-01` }
  ];
}

export function generateYearDropdown(startYear: number, endYear: number): { finYearName: string; id: string }[] {
  const options: { finYearName: string; id: string }[] = [];

  for (let year = startYear; year <= endYear; year++) {
    options.push({
      finYearName: `${year} - ${year + 1}`,
      id: `${year}-04-01`
    });
  }

  return options;
}

export function getCurrentFinYear() {
  return `${new Date().getFullYear()}-04-01`;
}

export function printRecept() {
  const alertService = inject(AlertService);
  const modalService = inject(ModalService);
  return (content: string = '') => {
    if (!content) {
      alertService.showToast('No Invoice Available to print', 'info');
      return;
    }
    const modalParams = {
      eventName: 'INVOICE',
      docContent: content
    };
    modalService.openModal(PrintDocComponent, modalParams, 'modal-lg', 2);
  }
}


export function isMobileUniqueValidation(control: AbstractControl): Promise<any> | Observable<any> {
  //@ts-ignore
  const self = this;
  const code = control.parent?.value?.country_code || '91';
  const phone = code + control.value;
  let regx = VALIDATOR_PATTERNS.MOBILE;
  const promise = new Promise<any>((resolve, reject) => {
    if (self.mobile_no && self.mobile_no == control.value) {
      resolve(null);
    }
    self.mobileCheckingloading = false;
    if (control.value && control.value.match(regx) !== null) {
      self.userApi.isUnique('mobile_no', phone).then((data: ResponseData) => {
        if (!data.result.length) {
          resolve(null);
        } else {
          resolve({ 'isNotUnique': true });
        }
      }).catch((error: any) => {
        resolve({ 'isNotUnique': true });
      }).finally(() => {
        self.mobileCheckingloading = false;
      });
    } else {
      resolve(null);
    }
  });
  return promise;
}

export function conditionalValidator(predicate: any, validator: any) {
  return ((formControl: any) => {
    if (!formControl.parent) {
      return null;
    }
    if (predicate()) {
      return validator(formControl);
    }
    return null;
  })
}

export function removeTableClass(elRef: any) {
  let el = elRef.nativeElement.querySelectorAll(".table-responsive div");
  el.forEach((cl: any) => {
    cl.classList.remove('ui-table-wrapper');
    cl.classList.remove('ui-table');
    cl.classList.remove('ui-widget');
    cl.classList.remove('ui-table-responsive');
    cl.classList.remove('ui-table-auto-layout');
    cl.classList.remove('ui-table-resizable');
    cl.classList.remove('ui-widget-header');
    cl.classList.remove('ui-table-thead');
  });

}

export function decryptData(data: any) {
  return data;
}

export function encryptData(data: any) {
  if (data === "")
    return;
  data = data.toString();
  return data;
}

export function isEmptyObj(obj: any) {
  if (obj && typeof obj === 'object') {
    return Object.getOwnPropertyNames(obj).length == 0;
  } else {
    return true;
  }
}

export function cloneData(data: any) {
  return structuredClone(data);
}

export function jsonParse(str: any) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}
export function isExistsKey(obj: any, props: Array<string>): any {
  var prop = props.shift();
  return prop === undefined ? true : obj.hasOwnProperty(prop) ? isExistsKey(obj[prop], props) : false;
}
export function uniqueArray(a: any) {
  return a.filter(function (i: any, p: any) {
    return a.indexOf(i) == p;
  });
}

export function sort(arr: any, prop: string, desc?: boolean) {
  arr.sort(function (a: any, b: any) {
    if (!a[prop]) return -1;
    return a[prop].localeCompare(b[prop], "en", { ignorePunctuation: true });
  });
  if (desc) arr.reverse();
  return arr;
}

export function arrayGroupBy(xs: any, f: any) {
  return xs.reduce((r: any, v: any, i: any, a: any, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
}
export function randomString(len: number, charSet = '') {
  charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < len; i++) {
    let randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
}

export function mysqlDataTime(fdate: any = new Date(), type: 'DATE' | 'DATETIME' = 'DATETIME') {
  if (!fdate) return '';
  const d = fdate instanceof Date ? fdate : new Date(fdate);
  const month = fdate instanceof Date ? d.getMonth() + 1 : d.getMonth();
  return type == 'DATE' ? `${d.getFullYear()}-${month}-${d.getDate()}` : `${d.getFullYear()}-${month}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}`
}

export function isValidUrl(url: any) {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}

export function toggleMenu(menubar: boolean = false, outsideCheck: boolean = false) {
  const className = 'sidebar-enable';
  const divId = 'custom-backdrop';
  const containCheck = document.documentElement.classList.contains(className);
  if (!menubar && outsideCheck && containCheck) {
    return;
  }
  if (!containCheck) {
    const div = document.createElement('div');
    div.id = divId;
    div.classList.add("offcanvas-backdrop", "fade", "show");
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = '15px';
    document.body.appendChild(div);
  } else {
    const div = document.getElementById(divId);
    if (div) {
      document.body.removeChild(div);
    }
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }
  document.documentElement.classList.toggle(className);
}

export function sumByKey(arr, key) {
  return arr.reduce((acc, obj) => acc + (+obj[key]), 0);
}

export function downloadJSON(data: any, filename: string) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();

  window.URL.revokeObjectURL(url);
}
export function getRandomColor(): string {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
export function calculateAge(date: string) {
  const dob = new Date(date);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }
  return `${age} years`
}

export function lastUrlSegment(mod, action) {
  return UrlServices.PAGE_URL[mod][action].URL.split(/[/]+/).pop()
}

export function urlPermission(mod, action) {
  return action ? UrlServices.PAGE_URL[mod][action].permission : {} as userPermission;
}